import React, { useState } from 'react';
import { useMobileMediaQuery } from '../config/mediaQuery';

export const ActionsContext = React.createContext(
  {}, // default value
);

const Props = {
  children: React.Node,
};

export const ActionsProvider = (props: Props) => {
  const [refresh, setRefresh] = useState(null);
  const [allScreens, setAllScreens] = useState([]);
  const [appTitle, setAppTitle] = useState(null);

  const isMobile = useMobileMediaQuery();

  const setFullScreenView = (view, title, onToggleVisibility) => {
    if (isMobile && !allScreens.find(o => o.title === title) && view !== null) {
      const arr = [...allScreens];
      arr.push({ view, title, onToggleVisibility });
      setAllScreens(arr);
    }
  };
  
  const goBack = () => {
    const arr = [...allScreens];
    let itemRemoved = arr.pop();
    itemRemoved.onToggleVisibility();
    let item = arr[0];
    if (item) {
      setAllScreens(arr);
    } else {
      setAllScreens([]);
    }
  }

  return (
    <ActionsContext.Provider value={{ refresh, setRefresh, setFullScreenView, goBack, allScreens, appTitle, setAppTitle }}>
      {props.children}
    </ActionsContext.Provider>
  )
}